<docs>
  # UiKit - Button - link
  > *generic way to create any link cta*
</docs>
  
<script lang="ts">
import ArrowLinkSVG from "assets/svg/arrow-link.svg?raw";
import { store as responsiveStore } from "components/Responsive/store";
import { computed, defineComponent, PropType, toRefs } from 'vue';
import UiButtonSimple from './index.vue';

const UiThemedButtonLink = defineComponent({
  name: "UiButtonThemedlink",
  components:{UiButtonSimple},
  extends:UiButtonSimple,
  props:{
    theme: {
      type: String as PropType<ButtonTheme>,
      default: 'link'
    },
    direction: {
      type:  String as PropType<ButtonDirection>,
      default: 'left'
    },
    icon: {
      type: String,
      default: ArrowLinkSVG
    },
    variant: {
      type: String,
      default: "default"
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    return {
      ...toRefs(props),
      t : computed( () => 10),
      hoverDistance: computed(() => `${10 * responsiveStore.desktop}px`),
      hoverDistanceNeg: computed(() => `${-10 * responsiveStore.desktop}px`),
    }
  }
});
export default UiThemedButtonLink
</script>
  
<template>
  <ui-button-simple class="UiButtonThemed"
                    :data-theme="theme"
                    :data-selected="selected"
                    :data-variant="variant"
                    :data-dark="dark"
                    v-bind="$props"
  />
</template>
  
<style lang="stylus" scoped>
  [data-theme="link"]
    display inline-block
    f-style(button)
    position relative
    &[data-dark="false"]
      addVariantProps($dark:false)
    &[data-dark="true"]
      addVariantProps($dark:true)
    &:after
      content ''
      absolute bottom 0px left
      width calc('100% - 10px')
      height 1px
      background currentColor
      transform scaleX(0)
      transform-origin left center
      trans(transform, $duration:0.75s)
    
    :deep()
      .inner
        .icon
          transform translateX(v-bind(hoverDistance)) scaleX(-1)
          transform-origin left center
          rp(width, 10px)
          rp(height, 10px)
          rp(margin-right, 1px)
          trans(all, $duration:0.5s)
        .label
          display inline-block
          trans(transform, $duration:0.5s)

    +hover()
      :deep()
        .inner
          .icon
            transform translate(0px, 0px) scaleX(0)
          .label
            transform translateX(v-bind(hoverDistanceNeg))
      &:after
        transform scaleX(1)

    &:focus
      :deep()
        .inner
          .icon
            transform translate(0px, 0px) scaleX(0)
          .label
            transform translateX(v-bind(hoverDistanceNeg))
      &:after
        transform scaleX(1)

        
  </style>
  